export enum AppRoutes {
  Login = 'login',
  LoginRedirect = 'login/redirect',
  Chat = 'chat',
  UserManagement = 'user-management',
  History = 'history',
  CaseHistory = 'case-history',
  Cases = 'cases',
  Projects = 'projects',
  Aerials = 'aerials',
  DocumentViewer = 'document-viewer',
  Actions = 'actions',
  AdminTools = 'admin-tools',
  HowWeFletch = 'how-we-fletch',
  /** Under `projects/:projectId`. */
  ProjectChatHistory = 'chat-history',
}

/**
 * A chat opened inside a project, `projects/:projectId/chat/:chatId`; no chat id is the page a new
 * project chat opens on.
 */
export const projectChatPath = (projectId: string, chatId?: string) =>
  `/${AppRoutes.Projects}/${projectId}/${AppRoutes.Chat}${chatId ? `/${chatId}` : ''}`;
